import Svg, { Path } from 'react-native-svg'

export const TimerIcon = ({ height = 20, width = 20, color = '#141414' }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <Path
        fill={color}
        d="M10 1.666a8.333 8.333 0 1 0 0 16.667 8.333 8.333 0 0 0 0-16.667Zm.833 9.167a.833.833 0 0 1-.833.833H7.5a.833.833 0 1 1 0-1.667h1.667V7.5a.833.833 0 0 1 1.666 0v3.334Z"
      />
    </Svg>
  )
}
